import React, { useMemo, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  IconButton,
  InputAdornment,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  Button,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import TimelineIcon from "@mui/icons-material/Timeline";
import TableRowsIcon from "@mui/icons-material/TableRows";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";

// -------- Sample Data Types & Helpers --------
const STATUS_COLORS = {
  Open: "default",
  Assigned: "info",
  "In Progress": "warning",
  Resolved: "success",
  Closed: "primary",
};

const SAMPLE_COMPLAINTS = [
  {
    id: "C-1001",
    subject: "Internet not working",
    customer: "John Doe",
    createdAt: "2025-08-01T09:30:00Z",
    priority: "High",
    status: "Resolved",
    assignee: "Tech Team A",
    history: [
      { when: "2025-08-01T09:30:00Z", what: "Created" },
      { when: "2025-08-01T10:10:00Z", what: "Assigned to Tech Team A" },
      { when: "2025-08-01T12:45:00Z", what: "Technician dispatched" },
      { when: "2025-08-02T08:20:00Z", what: "Resolved" },
    ],
  },
];

function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString();
  } catch (e) {
    return iso;
  }
}

function statusChip(status) {
  const color = STATUS_COLORS[status] || "default";
  return <Chip label={status} color={color} size="small" />;
}

// -------- Main Component --------
export default function ComplaintTimeline({ filteredComplaints }) {
  console.log(filteredComplaints, "filteredComplaints");
  return (
    <Box sx={{ p: 4, maxWidth: 1200 }}>
      <Card sx={{ borderRadius: 4, boxShadow: 3 }}>
        <CardHeader
          title={
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="h5" fontWeight={700}>
                Complaint TimeLine
              </Typography>
              <Chip label={`${filteredComplaints.length} shown`} size="small" />
            </Stack>
          }
        />
        <CardContent>
          <Stack spacing={3}>
            {filteredComplaints.map((c) => (
              <Card key={c.customerComplaintId} variant="outlined" sx={{ borderRadius: 3 }}>
                <CardHeader
                  title={
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography variant="h6" fontWeight={700}>
                        {c.complaintNumber}
                      </Typography>
                      <Divider orientation="vertical" flexItem />
                      <Typography variant="subtitle1">{c.priority}</Typography>
                      {statusChip(c.status)}
                      <Chip label={`Priority: ${c.priority}`} size="small" variant="outlined" />
                    </Stack>
                  }
                  subheader={`Customer: ${c.radUser?.userName}  •  Assignee: ${c.assignee}  •  Created: ${c.createdAt}`}
                />
                <CardContent>
                  <Timeline position="alternate">
                    {c.histories.map((h, idx) => (
                      <TimelineItem key={idx}>
                        <TimelineOppositeContent sx={{ flex: 0.25 }}>
                          <Typography variant="caption" color="text.secondary">
                            {formatDate(h.createdOn)}
                          </Typography>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineDot />
                          {idx < c.histories.length - 1 && <TimelineConnector />}
                        </TimelineSeparator>
                        <TimelineContent>
                          <Typography>{h.remarks}</Typography>
                        </TimelineContent>
                      </TimelineItem>
                    ))}
                  </Timeline>
                </CardContent>
              </Card>
            ))}
            {filteredComplaints.length === 0 && (
              <Typography sx={{ textAlign: "center", color: "text.secondary", py: 4 }}>
                No complaints match your filters.
              </Typography>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
